import React from 'react'
import News from "./images/news.jpg"

const Head = () => {
  return (
    <div className="website-body">
    <h1>The Cricketer Bro</h1>
    <h4>🏏 Welcome to Daily Updates with The Cricketer Bro! 🏏</h4>


    <p>At The Cricketer Bro, we bring you the latest in the world of cricket. Our daily updates cover everything you need to know about Cricket News, Live Link, Giveaways, Match Auctions, Quizzes, Memes, Stats, and much more!</p>
    <p>Follow us on Instagram to stay connected with the pulse of cricket and join a community of passionate cricket enthusiasts. 🌐</p>
  
    <img src={News} alt="" />
    
  </div>
  )
}

export default Head